import ge, { useState as A, useRef as Ie, useEffect as ee, createContext as he, useContext as ne, useMemo as O, useCallback as Ce, memo as ke } from "react";
import { SpinnerWidgetContainer as Ne, ErrorPage as Fe, SpinnerContainer as Le, NestedInfoWrapper as Me, CustomCodeBaseInfo as De, FileExplorer as Ue, ID_COLUMN as be, NAME_COLUMN as Ee, CREATED_COLUMN as je, UPDATED_COLUMN as ye, AUTHOR_COLUMN as Re, PageList as Be, FormElement as Z, FormActionsContainer as $e, ICON_COLUMN as ze, EntityTypeCell as Ye, NameCell as We, FloatingButton as qe } from "@prometheus/features";
import { useParams as Ge, useSearchParams as Ve, Routes as He, Route as de } from "react-router-dom";
import { api as I, getSortDirection as Je, createBreadcrumbsEntityConfig as Xe, createCrudEntityConfig as Qe, getPublishOriginBreadcrumb as Ze, createFiltersPanelListConfig as Se, createSortingMethodListConfig as ve, createCrudMethodsListConfig as Ke, populateColumnsConfigWithSort as et, separateSearchFilters as tt } from "@prometheus/utils";
import { Status as v, ListActions as me } from "@prometheus/types";
import { Spinner as ce, Grid as h, Block as Te, Select as rt, Input as nt, Textarea as fe, Button as te, Icon as U, Tooltip as ot, NewTable as st, FilterPanel as at, InputFilter as it, useNotifications as _e, IconButton as lt } from "@prometheus/components";
import { TypesOfContainer as re, EntityTypes as ct, EntityIconNames as ut } from "@prometheus/enums";
import { setBreadcrumbs as dt } from "@prometheus/redux";
import { useDispatch as mt } from "react-redux";
import { useEntityNew as ft, useSelectedConcepts as pt, useEntityList as xt, ModalContext as Pe } from "@prometheus/hooks";
import gt from "@emotion/styled";
var le = { exports: {} }, q = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pe;
function ht() {
  if (pe) return q;
  pe = 1;
  var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
  function o(s, i, c) {
    var m = null;
    if (c !== void 0 && (m = "" + c), i.key !== void 0 && (m = "" + i.key), "key" in i) {
      c = {};
      for (var d in i)
        d !== "key" && (c[d] = i[d]);
    } else c = i;
    return i = c.ref, {
      $$typeof: t,
      type: s,
      key: m,
      ref: i !== void 0 ? i : null,
      props: c
    };
  }
  return q.Fragment = n, q.jsx = o, q.jsxs = o, q;
}
var G = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xe;
function Ct() {
  return xe || (xe = 1, process.env.NODE_ENV !== "production" && function() {
    function t(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === $ ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case f:
          return "Fragment";
        case u:
          return "Profiler";
        case C:
          return "StrictMode";
        case k:
          return "Suspense";
        case B:
          return "SuspenseList";
        case L:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case T:
            return "Portal";
          case g:
            return (e.displayName || "Context") + ".Provider";
          case R:
            return (e._context.displayName || "Context") + ".Consumer";
          case V:
            var a = e.render;
            return e = e.displayName, e || (e = a.displayName || a.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case N:
            return a = e.displayName || null, a !== null ? a : t(e.type) || "Memo";
          case F:
            a = e._payload, e = e._init;
            try {
              return t(e(a));
            } catch {
            }
        }
      return null;
    }
    function n(e) {
      return "" + e;
    }
    function o(e) {
      try {
        n(e);
        var a = !1;
      } catch {
        a = !0;
      }
      if (a) {
        a = console;
        var l = a.error, p = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return l.call(
          a,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          p
        ), n(e);
      }
    }
    function s(e) {
      if (e === f) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === F)
        return "<...>";
      try {
        var a = t(e);
        return a ? "<" + a + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var e = H.A;
      return e === null ? null : e.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function m(e) {
      if (oe.call(e, "key")) {
        var a = Object.getOwnPropertyDescriptor(e, "key").get;
        if (a && a.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function d(e, a) {
      function l() {
        z || (z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          a
        ));
      }
      l.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: l,
        configurable: !0
      });
    }
    function b() {
      var e = t(this.type);
      return Y[e] || (Y[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function x(e, a, l, p, w, _, se, ae) {
      return l = _.ref, e = {
        $$typeof: y,
        type: e,
        key: a,
        props: _,
        _owner: w
      }, (l !== void 0 ? l : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: b
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: se
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ae
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function E(e, a, l, p, w, _, se, ae) {
      var j = a.children;
      if (j !== void 0)
        if (p)
          if (J(j)) {
            for (p = 0; p < j.length; p++)
              S(j[p]);
            Object.freeze && Object.freeze(j);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else S(j);
      if (oe.call(a, "key")) {
        j = t(e);
        var D = Object.keys(a).filter(function(Oe) {
          return Oe !== "key";
        });
        p = 0 < D.length ? "{key: someKey, " + D.join(": ..., ") + ": ...}" : "{key: someKey}", W[j + p] || (D = 0 < D.length ? "{" + D.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          p,
          j,
          D,
          j
        ), W[j + p] = !0);
      }
      if (j = null, l !== void 0 && (o(l), j = "" + l), m(a) && (o(a.key), j = "" + a.key), "key" in a) {
        l = {};
        for (var ie in a)
          ie !== "key" && (l[ie] = a[ie]);
      } else l = a;
      return j && d(
        l,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), x(
        e,
        j,
        _,
        w,
        i(),
        l,
        se,
        ae
      );
    }
    function S(e) {
      typeof e == "object" && e !== null && e.$$typeof === y && e._store && (e._store.validated = 1);
    }
    var P = ge, y = Symbol.for("react.transitional.element"), T = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), C = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), R = Symbol.for("react.consumer"), g = Symbol.for("react.context"), V = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), B = Symbol.for("react.suspense_list"), N = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), L = Symbol.for("react.activity"), $ = Symbol.for("react.client.reference"), H = P.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, oe = Object.prototype.hasOwnProperty, J = Array.isArray, M = console.createTask ? console.createTask : function() {
      return null;
    };
    P = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var z, Y = {}, X = P.react_stack_bottom_frame.bind(
      P,
      c
    )(), Q = M(s(c)), W = {};
    G.Fragment = f, G.jsx = function(e, a, l, p, w) {
      var _ = 1e4 > H.recentlyCreatedOwnerStacks++;
      return E(
        e,
        a,
        l,
        !1,
        p,
        w,
        _ ? Error("react-stack-top-frame") : X,
        _ ? M(s(e)) : Q
      );
    }, G.jsxs = function(e, a, l, p, w) {
      var _ = 1e4 > H.recentlyCreatedOwnerStacks++;
      return E(
        e,
        a,
        l,
        !0,
        p,
        w,
        _ ? Error("react-stack-top-frame") : X,
        _ ? M(s(e)) : Q
      );
    };
  }()), G;
}
process.env.NODE_ENV === "production" ? le.exports = ht() : le.exports = Ct();
var r = le.exports;
const bt = (t) => I.post("/library/custom-code/invites/zip", t), Et = (t) => I.post("/library/custom-code/invites", t), K = (t) => {
  const { pageNumber: n, pageSize: o, sortBy: s, query: i } = t, c = Je(s), m = `/library/custom-code/list?size=${o || ""}&page=${n || ""}&sort=${c}&${i || ""}`;
  return I.get(m);
}, we = (t) => {
  const n = `/library/custom-code/filter?${t}`;
  return I.get(n);
}, Ae = () => I.get("/library/custom-code/sorts"), jt = (t) => I.get(`/analysis/custom-code/${t}`), yt = (t) => I.get(`/analysis/custom-code/${t}/files`), Rt = (t, n) => I.put(`/analysis/custom-code/${n || (t == null ? void 0 : t.id)}`, t), St = "New cohort definition", vt = {
  createCrudEntity: (t, n) => Qe(
    t,
    n,
    jt,
    (o) => Promise.resolve(),
    Rt
  ),
  entityBreadcrumbs: (t, n, o, s) => Xe(St, t, n, o)
}, Tt = (t, n) => {
  const [o, s] = A(null), [i, c] = A(v.INITIAL), [m, d] = A([]), [b, x] = A(null), E = ft(n, t, "Custom code"), S = Ie(null), P = async () => {
    try {
      const y = await yt(t);
      d(
        y.map((T) => ({
          ...T,
          fileMetadata: T.metadata
        }))
      ), c(v.SUCCESS);
    } catch (y) {
      c(v.ERROR), x({
        response: y
      });
    }
  };
  return ee(() => {
    S.current = null;
  }, [t]), ee(() => {
    if (E.status === v.SUCCESS) {
      if (s(E.entity), S.current === t) {
        c(v.SUCCESS);
        return;
      }
      S.current = t, c(v.IN_PROGRESS), P();
      return;
    }
    if (E.status === v.ERROR) {
      o || (c(v.ERROR), x({
        response: { message: "Base entity is broken" }
      }));
      return;
    }
    o || c(v.IN_PROGRESS);
  }, [E.status]), {
    entity: o,
    files: m,
    status: i,
    error: b,
    actions: E.actions,
    updateEntity: E.updateEntity
  };
};
he({});
const _t = () => {
  const { id: t } = Ge(), n = mt(), [o] = Ve(), s = Ze(o.get("typePublish")), { rootSettings: i, path: c, title: m, config: d, subModules: b } = ne(
    ue
  ), { rootPath: x, rootTitle: E } = i, { parentId: S, parentTitle: P, typeContainer: y } = d, { createCrudEntity: T, entityBreadcrumbs: f } = vt, C = O(() => T(y, S), [S]), { entity: u, actions: R, error: g, files: V, status: k, updateEntity: B } = Tt(t, {
    get: C.getMethod,
    update: C.upsertMethod,
    delete: C.deleteMethod
  }), N = y === re.LIBRARY;
  u != null && u.actions && R != null && R[me.UPDATE];
  const F = !!(R[me.UPDATE] || R["update.name"] || R["update.description"]), L = o.get("from") && o.get("from") === re.LIBRARY;
  return ee(() => {
    u && n(
      dt(
        f(
          t,
          u == null ? void 0 : u.title,
          {
            path: (s == null ? void 0 : s.path) || c,
            title: (s == null ? void 0 : s.title) || m,
            rootPath: x,
            rootTitle: E,
            parentTitle: P,
            parentId: S
          },
          N
        )
      )
    );
  }, [c, u]), k === v.ERROR ? /* @__PURE__ */ r.jsx(Ne, { children: /* @__PURE__ */ r.jsx(Fe, { ...g.response, path: c }) }) : k === v.INITIAL || k === v.IN_PROGRESS ? /* @__PURE__ */ r.jsx(Le, { children: /* @__PURE__ */ r.jsx(ce, { size: 62 }) }) : /* @__PURE__ */ r.jsxs(h, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ r.jsx(Me, { children: /* @__PURE__ */ r.jsx(
      De,
      {
        entity: u,
        onSubmit: ($) => B($),
        onCopy: function($) {
        },
        versionPreview: !1,
        onVersionSave: function() {
        },
        viewMode: N,
        libraryMode: F,
        onDelete: function() {
          console.log("Function not implemented.");
        },
        onPublish: function() {
          console.log("Function not implemented.");
        },
        backToListPath: L ? "../../" : "",
        AdditionalActions: L && /* @__PURE__ */ r.jsx(
          b.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: b,
            config: {
              ...d,
              type: o.get("typePublish"),
              typeEntity: ct.CUSTOM_CODE,
              nameEntity: u == null ? void 0 : u.title,
              id: o.get("id"),
              isRedirect: !0,
              requestStatus: o.get("status")
            }
          }
        )
      }
    ) }),
    /* @__PURE__ */ r.jsx(h, { container: !0, children: /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
      Ue,
      {
        submissionId: u == null ? void 0 : u.id,
        url: "analysis/custom-code",
        files: V,
        heightCount: 150
      }
    ) }) })
  ] });
}, ue = he(null), Pt = (t) => {
  const { path: n, title: o, rootSettings: s } = t, i = O(() => s || { rootPath: n, rootTitle: o }, [s, n, o]);
  return /* @__PURE__ */ r.jsx(ue.Provider, { value: { ...t, rootSettings: i }, children: /* @__PURE__ */ r.jsxs(He, { children: [
    /* @__PURE__ */ r.jsx(de, { index: !0, element: /* @__PURE__ */ r.jsx(At, {}) }),
    /* @__PURE__ */ r.jsx(de, { path: ":id/*", element: /* @__PURE__ */ r.jsx(_t, {}) })
  ] }) });
}, wt = {
  rowId: "id",
  loadingMessage: "Loading cutom code...",
  addButtonTitle: "Add feature analysis",
  tableTitle: "Custom code",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (t, n) => Ke(
    t,
    n,
    K,
    () => Promise.resolve(),
    () => Promise.resolve(""),
    K,
    K
  ),
  cols: [
    be(),
    Ee({
      accessor: "title",
      accessorKey: "title"
    }),
    je(),
    ye(),
    Re()
  ],
  createSortingMethod(t) {
    return ve(t, {
      getSorting: Ae
    });
  },
  createFiltersPanel: (t, n) => Se(
    t,
    n,
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    we
  )
  // TODO add sorting
}, At = () => {
  const t = ne(
    ue
  );
  return /* @__PURE__ */ r.jsx(
    Be,
    {
      isImport: !1,
      moduleConfig: t,
      listConfig: wt,
      allowDelete: !0
    }
  );
}, Ot = {
  title: "",
  description: "",
  executableFileName: void 0,
  files: [],
  message: ""
}, It = ({
  onSubmit: t,
  onCancel: n,
  subModules: o
}) => {
  const [s, i] = A(Ot), [c, m] = A([]), [d, b] = A(), [x, E] = A(!1), S = O(() => !!(s.title && s.executableFileName), [s, x]), P = O(
    () => o == null ? void 0 : o.documents,
    [o == null ? void 0 : o.documents]
  ), y = Ce(async () => {
    const { message: f, ...C } = s;
    E(!0);
    try {
      const u = new FormData();
      u.append(
        "dto",
        new Blob([JSON.stringify(C)], {
          type: "application/json"
        })
      ), u.append("message", f || ""), Array.isArray(d) ? d == null || d.forEach((g) => u.append("files", g)) : u.append("file", d);
      const R = Array.isArray(d) ? await Et(u) : await bt(u);
      t(R);
    } catch (u) {
      console.log(u), t(null);
    } finally {
      n(), E(!1);
    }
  }, [t, s]), T = (f, C) => {
    const u = typeof C == "string" ? C : C.currentTarget.value;
    i((R) => ({
      ...R,
      [f]: u
    }));
  };
  return /* @__PURE__ */ r.jsxs(h, { container: !0, children: [
    /* @__PURE__ */ r.jsx(
      h,
      {
        item: !0,
        xs: 12,
        px: 2,
        sx: (f) => ({
          boxShadow: f.customShadows[2],
          background: "white"
        })
      }
    ),
    /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ r.jsx(Te, { children: /* @__PURE__ */ r.jsxs(h, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
        P,
        {
          type: "component",
          name: "upload-new-document",
          subModules: o,
          config: {
            freeUpload: !0,
            onChange: (f, C) => {
              const u = C ? Object.keys(C.files) : f;
              m((R) => u.map((g) => C ? C.files[g] : g).filter((g) => g.name.toLowerCase().includes(".sql") || g.name.toLowerCase().includes(".r")).map((g) => ({
                name: g.name,
                value: g.name
              }))), b(f);
            },
            localDownload: !0,
            textAvailableExt: "ZIP or bunch of SQL and R files"
          }
        }
      ) }),
      /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(Z, { name: "type", textLabel: "Entry point", required: !0, children: /* @__PURE__ */ r.jsx(
        rt,
        {
          className: "",
          name: "entry-point",
          disablePortal: !0,
          id: "entry point",
          options: c,
          value: s.executableFileName,
          placeholder: "Select entry point...",
          onChange: (f) => T("executableFileName", f),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
        Z,
        {
          name: "analysis-name",
          textLabel: "Analysis name",
          required: !0,
          children: /* @__PURE__ */ r.jsx(
            nt,
            {
              id: "analysis-name",
              name: "analysis-name",
              type: "text",
              size: "medium",
              onChange: (f) => T("title", f),
              value: s.title,
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(Z, { name: "description", textLabel: "Description", children: /* @__PURE__ */ r.jsx(
        fe,
        {
          id: "description",
          name: "description",
          value: s.description,
          onChange: (f) => T("description", f),
          maxRows: 10,
          minRows: 5,
          disableHorizontalResize: !0,
          placeholder: "Enter description"
        }
      ) }) }),
      /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(Z, { name: "message", textLabel: "Message", children: /* @__PURE__ */ r.jsx(
        fe,
        {
          id: "message",
          name: "message",
          value: s.message,
          onChange: (f) => T("message", f),
          maxRows: 5,
          minRows: 3,
          disableHorizontalResize: !0,
          placeholder: "Enter message"
        }
      ) }) }),
      /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs($e, { children: [
        /* @__PURE__ */ r.jsx(
          te,
          {
            variant: "outlined",
            onClick: n,
            startIcon: /* @__PURE__ */ r.jsx(U, { iconName: "deactivate" }),
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ r.jsx(
          te,
          {
            onClick: y,
            variant: "contained",
            disabled: !S || x,
            color: "success",
            startIcon: x ? /* @__PURE__ */ r.jsx(ce, { size: 16 }) : /* @__PURE__ */ r.jsx(U, { iconName: "submit" }),
            children: "Submit"
          }
        )
      ] }) })
    ] }) }) })
  ] });
}, kt = {
  createCrudMethod: (t, n) => ({
    fetch: (o, s, i, c) => {
      switch (t) {
        case re.STUDY:
        case re.WORKSPACE:
        default:
          return K({
            pageNumber: o,
            pageSize: s,
            sortBy: i,
            query: c
          });
      }
    }
  }),
  createFiltersPanel: (t, n) => Se(
    t,
    n,
    we
  ),
  createSortingMethod(t) {
    return ve(t, {
      getSorting: Ae
    });
  },
  cols: [
    ze({
      Header: "",
      accessorFn: () => ut.CUSTOM_CODE,
      id: "typeEntityIcon",
      width: "2%",
      cell: Ye
    }),
    be(),
    Ee({
      width: "20%",
      cell: (t) => {
        var n, o, s, i;
        return /* @__PURE__ */ r.jsx(
          ot,
          {
            text: (o = (n = t.row) == null ? void 0 : n.original) == null ? void 0 : o.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(We, { value: (i = (s = t.row) == null ? void 0 : s.original) == null ? void 0 : i.title }) })
          }
        );
      }
    }),
    je(),
    ye(),
    Re()
  ]
}, Nt = (t) => {
  const {
    onChange: n,
    typeContainer: o,
    parentId: s,
    isSelect: i = !1,
    onClose: c
  } = t, {
    createCrudMethod: m,
    createFiltersPanel: d,
    createSortingMethod: b,
    cols: x
  } = kt, E = O(() => m(o, s), [o, s]), S = O(() => d(o, s), [o, s]), P = O(() => b == null ? void 0 : b(o), [o, s]), {
    selectedConcepts: y,
    detectSelectedAction: T,
    updateSelectedConcept: f,
    clear: C
  } = pt({}, "id"), {
    data: { tableData: u, filtersData: R },
    filters: g,
    actions: V,
    pageCount: k,
    pageSize: B,
    isLoading: N,
    getEntity: F,
    totalElements: L,
    numberOfElements: $,
    removeEntity: H,
    isReloadLoading: oe,
    updateFilters: J,
    allowedSorting: M,
    status: z
  } = xt(
    {
      get: E.fetch,
      remove: () => {
      },
      getFilters: S.getFilters,
      getSorting: P
    },
    "",
    !1
  ), Y = (l) => {
    console.log(l), n(i ? Object.keys(y) : [l.original]), c();
  }, X = Ce((l, p) => {
    const w = {};
    l == null || l.forEach((_) => {
      w[_.id] = _;
    }), T(w, p);
  }, []), Q = O(
    () => et(x, M),
    [M]
  ), W = Object.keys(y).length, { otherFilters: e, searchFilter: a } = tt(R);
  return /* @__PURE__ */ r.jsx(h, { container: !0, children: /* @__PURE__ */ r.jsx(Te, { elevated: !0, outlined: !0, children: /* @__PURE__ */ r.jsxs(h, { container: !0, className: "table-list-features-widget", pb: 0, children: [
    /* @__PURE__ */ r.jsx(
      qe,
      {
        onAdd: () => {
          Y();
        },
        onClear: C,
        selectedConceptsCount: W,
        buttonText: "Add feature to analysis",
        width: W != null ? "calc(100% - 250px)" : window.innerWidth - 250 + "px"
      }
    ),
    /* @__PURE__ */ r.jsx(h, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ r.jsx(
      st,
      {
        enableRowSelection: i,
        variant: "controlled",
        noDataText: "No data currently available",
        data: u,
        columns: Q,
        pageCount: k,
        pageSize: B,
        loading: N,
        loadingMessage: "",
        fetchData: F,
        totalElements: L,
        selectedRowIds: y,
        onRowSelect: X,
        onRowClick: i ? () => {
        } : Y,
        getRowId: (l) => String(l.id),
        showFilterToggle: !0,
        searchComponent: a && /* @__PURE__ */ r.jsx(
          it,
          {
            ...a,
            value: g == null ? void 0 : g[a == null ? void 0 : a.name],
            onChange: (l) => J({ [a == null ? void 0 : a.name]: l })
          }
        ),
        children: /* @__PURE__ */ r.jsx(
          at,
          {
            showLabel: !0,
            filters: e,
            value: g,
            onChange: (l, p) => J({ [l]: p }),
            isLoading: z === v.IN_PROGRESS,
            isReloading: z === v.IN_PROGRESS_RELOAD
          }
        )
      }
    ) })
  ] }) }) });
}, Ft = (t) => {
  const { openModal: n, closeModal: o } = ne(Pe), { enqueueSnackbar: s } = _e(), i = (m) => {
    if (console.log(m), !m) {
      s(m.message, { variant: "error" });
      return;
    }
    s("Custom code submission successfully created.", {
      variant: "success"
    });
  }, c = () => {
    n(
      () => /* @__PURE__ */ r.jsx(
        It,
        {
          subModules: t.subModules,
          onCancel: o,
          onSubmit: i
        }
      ),
      "Publish custom analysis code",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: o
      }
    );
  };
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(
    te,
    {
      variant: "outlined",
      onClick: c,
      startIcon: /* @__PURE__ */ r.jsx(U, { iconName: "publish" }),
      name: "delete",
      children: "Publish"
    }
  ) });
}, Lt = (t) => {
  const { onChange: n, isLoading: o } = t, { openModal: s, closeModal: i } = ne(Pe), { enqueueSnackbar: c } = _e(), m = () => {
    s(
      () => /* @__PURE__ */ r.jsx(Nt, { onChange: n, onClose: i }),
      "Import custom code",
      {
        onClose: i,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(
    te,
    {
      variant: "contained",
      color: "info",
      onClick: m,
      startIcon: o ? /* @__PURE__ */ r.jsx(ce, { size: 16 }) : /* @__PURE__ */ r.jsx(U, { iconName: "download", sx: { transform: "rotate(180deg)" } }),
      name: "delete",
      disabled: o,
      sx: {
        ml: 1.5,
        px: 2,
        borderColor: "borderColor.main",
        ".start-icon-small svg": {
          fontSize: 16
        }
      },
      children: "Import custom code"
    }
  ) });
}, Mt = gt(h, {
  shouldForwardProp: (t) => t !== "isActive"
})`
  font-size: 14px;
  color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
  font-weight: 400;
  border-bottom: 1px solid
    ${({ theme: t }) => t.palette.borderColor.light};
  position: relative;
  background-color: ${({ isActive: t, theme: n }) => t ? n.palette.info.main + 20 : "transparent"};
  :hover {
    background-color: ${({ theme: t, isActive: n }) => t.palette.info.main + (n ? 20 : 10)};
  }
  span {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
`, Dt = (t) => {
  const { initialState: n, onChange: o } = t, [s, i] = A({}), [c, m] = A(!1);
  return ee(() => {
    m(!0), console.log(n);
    const d = n.reduce((b, x) => (b[x] || (b[x] = {}), b[x] = { id: x, name: "Name" + x, version: "version" + x }, b), {});
    i(d);
  }, [n]), /* @__PURE__ */ r.jsx(h, { container: !0, children: Object.values(s).map((d) => /* @__PURE__ */ r.jsx(h, { item: !0, container: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(Mt, { xs: 12, px: 1, py: 0.5, children: [
    /* @__PURE__ */ r.jsx(U, { iconName: "info", sx: { fontSize: 26 } }),
    /* @__PURE__ */ r.jsx("span", { children: d.name }),
    /* @__PURE__ */ r.jsx("span", { children: d.version }),
    /* @__PURE__ */ r.jsx(
      lt,
      {
        size: "small",
        onClick: () => {
          o([d.id]);
        },
        children: /* @__PURE__ */ r.jsx(U, { iconName: "delete", sx: { fontSize: 26 } })
      }
    )
  ] }, d.id) }, d.id)) });
}, Ut = ke((t) => {
  const { name: n, config: o, ...s } = t, { instanceId: i, initialState: c, onChange: m, isLoading: d } = o;
  return /* @__PURE__ */ r.jsxs(ge.Fragment, { children: [
    n === "publish-custom-code" && /* @__PURE__ */ r.jsx(Ft, { ...s }),
    n === "add-custom-code-button" && /* @__PURE__ */ r.jsx(
      Lt,
      {
        ...s,
        onChange: m,
        instanceId: i,
        isLoading: d
      }
    ),
    n === "list-current-custom-code" && /* @__PURE__ */ r.jsx(
      Dt,
      {
        instanceId: i,
        initialState: c,
        onChange: m,
        ...s
      }
    )
  ] });
}), Qt = (t) => {
  const { type: n } = t;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    !n && /* @__PURE__ */ r.jsx(Pt, { ...t }),
    n === "component" && /* @__PURE__ */ r.jsx(Ut, { ...t })
  ] });
};
export {
  Qt as CustomCode
};
//# sourceMappingURL=custom-code.js.map
